// extracted by css-extract-rspack-plugin
export default {"StatusAvatar":"StatusAvatar-module__StatusAvatar__A5iE9"};